import { render, staticRenderFns } from "./MrBrand.vue?vue&type=template&id=3ba4214a&"
import script from "./MrBrand.vue?vue&type=script&lang=js&"
export * from "./MrBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports